import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-content">
        <div className="footer-logo">
          <svg width="40" height="40" viewBox="0 0 50 50" fill="none">
            <circle cx="25" cy="25" r="23" stroke="currentColor" strokeWidth="2"/>
            <path d="M15 25 L22 32 L35 18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Shahd Abubaker</span>
        </div>
        
        <div className="footer-links">
          <a href="#home">Home</a>
          <a href="#about">Professional Overview</a>
          <a href="#skills">Skills</a>
          <a href="#projects">Projects</a>
          <a href="#contact">Contact</a>
        </div>
        
        <div className="footer-social">
          <a href="mailto:me@shahd.me" target="_blank" rel="noopener noreferrer" aria-label="Email">
            <svg viewBox="0 0 24 24" fill="none">
              <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
              <path d="M2 7 L12 13 L22 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a href="https://linkedin.com/in/shahdabubaker" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <svg viewBox="0 0 24 24" fill="none">
              <rect x="2" y="2" width="20" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
              <path d="M8 11v5M8 8v.5M12 16v-4a2 2 0 0 1 4 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </a>
          <a href="https://wa.me/962780000270?text=I'm%20interested%20in%20your%20services" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <svg viewBox="0 0 24 24" fill="none">
              <rect x="2" y="2" width="20" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
              <path d="M8 11v5M8 8v.5M12 16v-4a2 2 0 0 1 4 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </a>
          
        </div>
        
        <div className="footer-bottom">
          <p>Designed & Built with ❤️ by Shahd Abubaker</p>
          <p className="copyright">© 2026 Shahd Abubaker. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

